export default {
  default_header: require('./default_header.jpg'),
  arrow_right: require('./arrow_right.jpg'),
  default_logo: require('./default_logo.jpg'),
  empty_program: require('./empty_cart.png')
}
